import { Text } from "@ui/components/content/text/Text";
import { Switch } from "@ui/components/forms/switch/Switch";
import { Flex } from "@ui/components/layout/flex/Flex";
import { useContext } from "react";

import { Controller } from "@components/store-locator/controller";
import { textStyle, wrapperStyle } from "./StoresToggle.styles";
import { Progress } from "@ui/components/other/progress/Progress";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { storeLocator } from "@lib/constants/contentful/storeLocator";
import { PARTNER_STORES_SWITCH } from "@e2e/helpers/store-locator/constants/common";

export const StoresToggle = () => {
    const { get: getMicrocopy } = useMicrocopy();

    const { setShowPartnerStores, showPartnerStores, isLoading } = useContext(Controller);

    const onToggle = () => setShowPartnerStores((prev) => !prev);

    const title = getMicrocopy(CommonCMS.page, storeLocator.partnerStores);
    const ariaToggleLabel = getMicrocopy(CommonCMS.page, storeLocator.ariaLabels.loadingToggleAria);

    return (
        <Flex gap={2} justify="center" align="center" sx={wrapperStyle}>
            {isLoading ? (
                <Progress
                    isIndeterminate
                    variant="buttonLoader"
                    aria-label={ariaToggleLabel || "Loading partner stores"}
                />
            ) : (
                <>
                    <Text as="label" id="storeSwitchLabel" sx={textStyle}>
                        {title}
                    </Text>
                    <Switch
                        aria-labelledby="storeSwitchLabel"
                        data-testid={PARTNER_STORES_SWITCH}
                        isChecked={showPartnerStores}
                        onChange={onToggle}
                    ></Switch>
                </>
            )}
        </Flex>
    );
};
